import { Layout } from 'antd'
import React from 'react'
import RegistrationForm from '../../components/Consultant/RegistrationForm'

const ConsultantRegister = () => {
    return (
        <Layout>
            <Layout.Content>
                <RegistrationForm/>
            </Layout.Content>
        </Layout>
    )
}

export default ConsultantRegister
